import { Box, Card, Grid2 as Grid, Link, Stack, Typography, useTheme } from '@mui/material';


interface Props {
   reason: string;
   previousReportId: number;
}

const ReportAmendReasonBlock = (props: Props): JSX.Element => {

    const theme = useTheme();
    
    const fieldWidth = { xs: "50%", sm: "40%", md: "35%" };

    return (
        <Grid size={12}>
            <Box
                component={Card}
                boxShadow={0}
                sx={{ bgcolor: 'alternate.main' }}
                border={`1px solid ${theme.palette.divider}`}
            >
            <Box padding={{ xs: 2, sm: 3 }}>
                <Stack direction="row" spacing={1} marginBottom={2}>
                    <Typography component={"i"} variant={'body1'} width={fieldWidth}>
                        Amendment?:
                    </Typography>
                    <Typography variant={'body1'} fontWeight={550} align='left'>
                        Yes, <Link href={`/reports/displayreport?id=${props.previousReportId}`} underline="none">Click to see the previous report</Link>
                    </Typography>
                </Stack>
                <Stack direction="row" spacing={1} marginBottom={2}>
                    <Typography variant={'body1'} width={fieldWidth}>
                        Amendment Reason:
                    </Typography>
                    <Typography component={"i"} variant={'body1'} align='left'>
                        {props.reason}
                    </Typography>
                </Stack>
            </Box>
            </Box>
        </Grid>
    );
}

export default ReportAmendReasonBlock;